export default function isArray(input) {
    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
}



//////////////////
// WEBPACK FOOTER
// ./~/moment/src/lib/utils/is-array.js
// module id = 28
// module chunks = 0